// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_PackMarketInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Upsert a per-market price row for an AI credit pack.
 *
 * POST /ai/credits/packs/{id}/prices
 *
 * Required fields:
 *   currency      (string)   — ISO 4217 uppercase; allowlist derived from
 *                              GatewayCapabilities::allKnownCurrencies() (D5)
 *   price_cents   (int)      — price in cents; must be > 0
 *   provider_code (string)   — gateway provider code; REQUIRED; validated against
 *                              the capability matrix (gateway known + currency supported).
 *                              Registration/enablement is enforced at checkout, not here.
 *   countries     (string[]) — ISO 3166-1 alpha-2 country codes; must be non-empty
 *
 * Note: provider_price_ref is intentionally absent for packs — packs are
 * one-off charges, not recurring subscriptions (no Stripe Price objects).
 *
 * B1 (vitrine ≡ caixa, 2026-08-06): for every country in $countries that IS a
 * declared billing market (MarketPolicy::isMarketCountry), $currency must
 * be one of that market's currencies (MarketPolicy::isMarketCurrency) — rejected
 * as 'country_currency_mismatch: <CC> is a <CUR> market' otherwise. A
 * non-market country is skipped (forward-provisioning ahead of a market
 * going live is legal, same posture as the provider_code check above). This
 * closes the divergence where the storefront (keyed by country) could offer
 * a price row the checkout (keyed by the country's market currency) would
 * then refuse with no_price_for_pack_currency_gateway.
 */
import { registerContract } from './validate'

export interface AiCredits_PackMarketInput {
currency: string
price_cents: number
provider_code: string
countries: string[]
}

registerContract('AiCredits_PackMarketInput', {
  currency:      { type: 'string',  required: true },
  price_cents:   { type: 'number',  required: true },
  provider_code: { type: 'string',  required: true },
  countries:     { type: 'array',   required: true },
})
